import React from 'react';

import '../icon-component.scss';

const LogoComponent = () => (
  <svg className="icon-component" viewBox="-0.5 -0.5 120 40" enableBackground="new -0.5 -0.5 120 40">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill="#00945E"
        d="M49.5 26.8L58.7 9c.3-.7.8-1.1 1.6-1.1.9 0 1.6.6 1.6 1.6V31c0 .9-.6 1.7-1.6 1.7-1.1 0-1.7-.8-1.7-1.7V16l-7.3 14c-.6.9-1.3 1.1-1.8 1.1-.4 0-1.2-.1-1.8-1.1l-7.3-14v15c0 .9-.6 1.7-1.7 1.7-1 0-1.6-.8-1.6-1.7V9.6c0-1.1.7-1.6 1.6-1.6.8 0 1.2.4 1.6 1.1l9.2 17.7zm28.4 3c-5.2 0-9.5-4.2-9.5-9.5 0-5.2 4.2-9.5 9.5-9.5 5.2 0 9.5 4.2 9.5 9.5s-4.3 9.5-9.5 9.5m12.7-9.5c0-7-5.7-12.7-12.7-12.7s-12.7 5.7-12.7 12.7S70.9 33 77.9 33s12.7-5.7 12.7-12.7m15.7 9.5c-5.2 0-9.5-4.2-9.5-9.5 0-5.2 4.2-9.5 9.5-9.5 5.2 0 9.5 4.2 9.5 9.5s-4.3 9.5-9.5 9.5m12.7-9.5c0-7-5.7-12.7-12.7-12.7s-12.7 5.7-12.7 12.7S99.3 33 106.3 33 119 27.3 119 20.3M13 35.6c3.1 0 5.9-1.4 7.8-3.8 1.3-1.7 2-3.8 2-6 0-.7-.1-1.3-.2-2-.4-2.2-2.1-6-5-11.1C15.4 8.8 13.5 6 13.5 6l-.5-.7-.4.6s-1.9 2.9-4.1 6.7c-3 5.1-4.7 8.9-5 11.1-.1.7-.2 1.3-.2 2 0 2.2.7 4.2 2 6 1.8 2.5 4.6 3.9 7.7 3.9m0 3.4c-4.1 0-7.8-1.8-10.3-5.1C.9 31.6 0 28.9 0 26c0-.9.1-1.8.3-2.6.5-2.9 2.6-7.6 6.4-14.1C9.5 4.5 11.8.9 11.9.9c.2-.4.5-.9 1.1-.9s.9.5 1.2.9c0 0 2.4 3.6 5.2 8.4 3.8 6.5 5.9 11.2 6.4 14.1.2.8.3 1.7.3 2.6 0 2.9-.9 5.6-2.7 7.9C20.8 37.1 17 39 13 39"
      />
    </g>
  </svg>
);

LogoComponent.displayName = 'LogoIcon';

export default LogoComponent;
